/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    sessionId: number;
    questionId: number;
    timing: string;
    note_state: number;
    name: string;
    comment: string;
    extendComment: string;
    comment_id: number;
}

interface IOutput {
    comment_id: number;
    points_result: IPointsResult;
}

export const weikeCommentSubmit = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.WEIKE_COMMENT_SUBMIT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
